import React, { SyntheticEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Tab, Tabs, Typography } from '@mui/material';
import { Box } from '@mui/system';
import './HistoryStatistics.scss';
import HistoryDailyStatistics from './HistoryDailyStatistics';
import HistoryMonthlyStatistics from './HistoryMonthlyStatistics';

interface TabPanelProps {
  // eslint-disable-next-line react/require-default-props
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <Card
      className="category-container"
      sx={{ p: 0 }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </Card>
  );
}

const a11yProps = (index: number) => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`,
});

export default function HistoryStatistics() {
  const { t } = useTranslation();

  const [value, setValue] = useState(0);

  const handleChangeTabs = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Card className="category-container" sx={{ p: 0 }}>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChangeTabs} aria-label="basic tabs example" centered>
            <Tab label={t('HistoryStatistics.tab1')} {...a11yProps(0)} />
            <Tab label={t('HistoryStatistics.tab2')} {...a11yProps(1)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <HistoryDailyStatistics />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <HistoryMonthlyStatistics />
        </TabPanel>
      </Box>
    </Card>
  );
}
